import { Loader2 } from 'lucide-react';

export const Loader = (): JSX.Element => (
  <Loader2 className="text-blue-500 animate-spin" size="3em" />
);

export const FullLoader = (): JSX.Element => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <Loader />
    </div>
  );
};

export const ScreenLoader = (): JSX.Element => {
  return (
    <div className="flex items-center justify-center w-screen h-screen">
      <Loader />
    </div>
  );
};
